export default __webpack_public_path__ + "static/media/app_name.7389f91f.png";